export const getChangeBranchViewAction = "MEMEBER_SERVICE/VIEW/CHANGE_BRANCH";
export const getChangeBranchSuccessAction = "MEMEBER_SERVICE/VIEW/CHANGE_BRANCH/SUCCESS";
export const getChangeBranchFailAction = "MEMEBER_SERVICE/VIEW/CHANGE_BRANCH/FAIL";
export const getChangeBranchResetAction = "MEMEBER_SERVICE/VIEW/CHANGE_BRANCH/RESET";
